import ServicesList from "../../Components/Services/ServicesList";
import Footer from "../../layout/Footer";
import Header from "../../layout/Header";
import Pagebanner from "../../layout/Banner";
import { Helmet } from "react-helmet";

const PracticeAreas = () => {
  return (
    <>
  
      <Header />
      <Pagebanner title="Practice Areas" subtitle="Our Practice Areas" />
      <ServicesList />
      <Footer />
    </>
  );
};
export default PracticeAreas;
